module.exports = __webpack_public_path__ + "media/images/photo-frame-9dd42ed97aaabf891341bd511767676a.png";